import React from 'react';
import { FadeIn } from './FadeIn';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    title: 'Lista de productos listos para vender en Amazon',
    description: 'Accede a ideas reales con demanda comprobada para empezar sin perder tiempo ni dinero.',
    value: 85,
    image: 'https://cdn.magicpatterns.com/uploads/pCqXRtbdWGJeAzDY9PXmug/bono1.png',
    alt: 'Lista de productos listos para vender en Amazon'
  }, {
    title: 'Plantilla premium práctica para elegir productos ganadores',
    description: 'Evalúa productos con un sistema claro antes de invertir y toma decisiones con seguridad.',
    value: 65,
    image: 'https://cdn.magicpatterns.com/uploads/6cF86EyiJhNAjHYCuYo7pZ/bono2.png',
    alt: 'Plantilla premium para elegir productos ganadores'
  }, {
    title: 'Checklist completo para lanzar tu producto sin errores',
    description: 'Sigue cada paso correctamente y evita los errores que hacen perder dinero al empezar.',
    value: 45,
    image: 'https://cdn.magicpatterns.com/uploads/2Xnkv8uXBoY3UbjVsMEKcy/bono3.png',
    alt: 'Checklist completo para lanzar tu producto sin errores'
  }];
  return <section className="bg-brand-white py-24 px-6" data-id="element-23">
      <div className="max-w-6xl mx-auto" data-id="element-24">
        <FadeIn data-id="element-25">
          <div className="text-center mb-16" data-id="element-26">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-beige rounded-full mb-6" data-id="element-27">
              <Gift className="w-8 h-8 text-brand-gold" data-id="element-28" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-brand-green" data-id="element-29">
              🎁 HOY RECIBES TODO ESTE SISTEMA:
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-30">
          {bonuses.map((bonus, index) => <FadeIn key={index} delay={0.15 * index} data-id="element-31">
              <div className="bg-brand-beige/30 border border-brand-beige rounded-2xl shadow-sm hover:shadow-md hover:border-brand-gold/30 transition-all h-full flex flex-col" data-id="element-32">
                {/* Image */}
                <div className="p-5 pb-0" data-id="element-33">
                  <img src={bonus.image} alt={bonus.alt} className="w-full h-auto rounded-xl object-contain" data-id="element-34" />
                </div>

                {/* Content */}
                <div className="p-6 pt-5 flex flex-col flex-1 text-center" data-id="element-35">
                  <h3 className="text-lg md:text-xl font-bold text-brand-text mb-3" data-id="element-36">
                    {bonus.title}
                  </h3>
                  <p className="text-brand-text/70 text-sm md:text-base leading-relaxed mb-5 flex-1" data-id="element-37">
                    {bonus.description}
                  </p>
                  <div className="flex items-center justify-center gap-2" data-id="element-38">
                    <span className="text-xs font-semibold uppercase tracking-wider text-brand-text/50" data-id="element-39">
                      Valor:
                    </span>
                    <span className="text-2xl font-bold text-brand-gold line-through decoration-brand-green/30" data-id="element-40">
                      ${bonus.value}
                    </span>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.5} data-id="element-41">
          <div className="text-center" data-id="element-42">
            <p className="text-2xl md:text-3xl font-bold text-brand-green" data-id="element-43">
              💥 TODO INCLUIDO SIN COSTO ADICIONAL
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}